import { IS_PRODUCTION } from '@/constants/index.js'

interface User {
	id: string
	name: string
	email?: string
	emailId: string
}

interface MetaData {
	[key: string]: any
}

interface ReportErrorParams {
	error: Error
	showToast?: boolean
	toast?: {
		title: string
		message: string
	}
	metaData?: MetaData
	user?: User
}

export function useErrorReporter() {
	const handleToast = useToast()
	const bugsnagReport = ({
		error,
		showToast = false,
		toast = {
			title: 'Oops!',
			message: 'Something went wrong. Please try again later.'
		},
		metaData,
		user
	}: ReportErrorParams) => {
		const {
			title, message
		} = toast
		if (showToast) {
			handleToast.add({
				title,
				description: message,
				color: 'error'
			})
		}

		useBugsnag().notify(error, event => {
			if (metaData) {
				event.addMetadata('data', metaData)
			}
			if (user) {
				event.setUser(user.id, user.email, user.name)
			}
		})

		if (!IS_PRODUCTION) {
			console.log(error)
		}
	}

	return {
		bugsnagReport
	}
}
